import React from 'react';
import cnames from 'classnames';
import PropTypes from 'prop-types';
import UserSettings from '../UserSettings';
import _styles from './themes/default.module.css';

const FooterSettings = ({ isInView, baseUrl, returnUrl, userInfo,
  onToggleMatureContent, styles, parentStyles, intl }: any) => (
    <div
      className={cnames(
        styles.footerSettings,
        parentStyles.footerSettings,
      )}
    >
      <div className={styles.footerContainer}>
        {
          isInView && (
            <UserSettings
              baseUrl={baseUrl}
              intl={intl}
              userInfo={userInfo}
              returnUrl={returnUrl}
              onToggleMatureContent={onToggleMatureContent}
            />
          )
        }
      </div>
    </div>
);

(FooterSettings as any).propTypes = {
  intl: PropTypes.shape({}).isRequired,
  styles: PropTypes.shape({}),
  parentStyles: PropTypes.shape({}).isRequired,
  baseUrl: PropTypes.string.isRequired,
  returnUrl: PropTypes.string.isRequired,
  isInView: PropTypes.bool.isRequired,
  userInfo: PropTypes.shape({
    locale: PropTypes.string,
    country: PropTypes.string,
    currency: PropTypes.string,
  }),
  onToggleMatureContent: PropTypes.func,
};

(FooterSettings as any).defaultProps = {
  styles: _styles,
  userInfo: {},
  onToggleMatureContent: () => {},
};

(FooterSettings as any).displayName = 'FooterSettings';

export default FooterSettings;
